// @ts-ignore
import Index from './src/Index.vue'
import {withInstall} from "../../utils/install";

Index.name = 'full-content';
export const FullContent = withInstall(Index);

export default FullContent;
